import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const MentionNode = inlineAtomNode('mention', 'a', {
  reference: { dataAttr: 'data-reference' },
  display: { isDisplay: true },
  /* The label an AI author wrote for this chip, set by the suggestion pipeline
   * and never by the @-picker. `display` cannot answer this: it round-trips as
   * the anchor's own text, so the picker's copy of the live resource and a
   * skill's citation prose land in the same string. Null on every mention a
   * clinician placed. */
  authoredLabel: { dataAttr: 'data-authored-label' },
  /* A label derived from the resource itself, as the AI source excerpt's chip
   * does. Distinct from `authoredLabel`, which is the model's own prose and is
   * honoured only behind `ai-citation-mentions`; this one is honoured
   * unconditionally, because there is no author to distrust. */
  derivedLabel: { dataAttr: 'data-derived-label' },
  /* A UUID created when a clinician types `@`, so the one tab that typed it can
   * open the picker on mount — it keys a `window` registry that the node view
   * clears a tick later, and that every page load re-initialises empty. A
   * persisted value can therefore never resolve on any client, so it is
   * transient and stays out of stored note HTML. */
  openId: { dataAttr: 'data-open-id', transient: true },
  /* The accept pipeline's stamp identity for a condition mention an AI accept
   * staged. The sign gate reads it to keep blocking on a mention whose linkage
   * has not completed, so a draft-flagged mention must not silently clear on
   * the next load. */
  acceptId: { dataAttr: 'data-accept-id' },
})
